module.exports = __webpack_public_path__ + "img/aws.83a86672.webp";